var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-container',{attrs:{"title":"Error 404","description":"","icon":"mdi-error"}},[_vm._v(" Pagina non esistente ")])}
var staticRenderFns = []

export { render, staticRenderFns }